// @flow

import {
    SET_CURRENT_VERSION,
    SHOW_UPDATE_AVAILABLE,
    HIDE_UPDATE_AVAILABLE,
} from "./actions";

const initialState = {
    currentVersion: "",
    updateAvailable: false,
};

export default function VersionReducer(state = initialState, action: any) {

    switch (action.type) {
        case SET_CURRENT_VERSION:
            return {
                ...state,
                currentVersion: action.payload,
            };

        case SHOW_UPDATE_AVAILABLE:
            return {
                ...state,
                updateAvailable: true,
            };

        case HIDE_UPDATE_AVAILABLE:
            return {
                ...state,
                updateAvailable: false,
            };

        default:
            return state;
    }
}